import React from "react";
import "./Header.css";

const Header = (props) => {
  return (
    <header className="header">
      <nav className="headerMenu">
        {/* a href .. odkaz na zjednodusene stranky
         */}
      </nav>
      <div>
        <a href="#" onClick={() => props.changeLang("cs-CZ")}>
          <img alt="česky" src={require("../../../assets/icons/cs.png")} />
        </a>
        <a href="#" onClick={() => props.changeLang("en-GB")}>
          <img alt="english" src={require("../../../assets/icons/en.png")} />
        </a>
        <a href="#" onClick={() => props.changeLang("de-DE")}>
          <img alt="deutch" src={require("../../../assets/icons/de.png")} />
        </a>
        <a href="#" onClick={() => props.changeLang("fr-FR")}>
          <img alt="français" src={require("../../../assets/icons/fr.png")} />
        </a>
      </div>
    </header>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/UI/Header/Header.jsx